import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";

import { rootReducer } from "./root-reducer";

const middleWares = [];

const persistConfig = {
  key: "root",
  version: 1, // Bump this to clear cache if needed
  storage,
  whitelist: ["cart", "products"], // Persist cart and products
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(middleWares),
});

export const persistor = persistStore(store);
